import { render, staticRenderFns } from "./ClientsView.vue?vue&type=template&id=bec8518a&scoped=true&"
import script from "./ClientsView.vue?vue&type=script&lang=js&"
export * from "./ClientsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec8518a",
  null
  
)

export default component.exports